/**
 * PostGenerationSkeleton Component
 * Feature 014: Unified Multi-AI Post Generation Flow
 * T046: Loading skeleton for post generation phase (1-3 dynamic columns)
 */

import { memo } from 'react';

interface IPostGenerationSkeletonProps {
  modelCount: number; // 1, 2, or 3
}

const PostGenerationSkeleton = ({ modelCount }: IPostGenerationSkeletonProps) => {
  // Dynamic grid class based on model count
  const gridClass = modelCount === 1
    ? 'grid grid-cols-1 gap-6'
    : modelCount === 2
    ? 'grid grid-cols-1 gap-6 lg:grid-cols-2'
    : 'grid grid-cols-1 gap-6 lg:grid-cols-3';

  // Color schemes for each model
  const colorSchemes = [
    { bg: 'bg-purple-50', border: 'border-purple-200', accent: 'bg-purple-200' }, // Claude
    { bg: 'bg-blue-50', border: 'border-blue-200', accent: 'bg-blue-200' },       // Gemini
    { bg: 'bg-green-50', border: 'border-green-200', accent: 'bg-green-200' },    // OpenAI
  ];

  return (
    <div className={gridClass}>
      {Array.from({ length: modelCount }).map((_, index) => {
        const colors = colorSchemes[index] || colorSchemes[0];

        return (
          <div key={index} className={`rounded-lg border ${colors.border} ${colors.bg} p-6`}>
            <div className="mb-4 flex items-center justify-between">
              <div className={`h-6 w-32 animate-pulse rounded ${colors.accent}`} />
              <div className={`h-4 w-16 animate-pulse rounded ${colors.accent}`} />
            </div>
            <div className="space-y-4">
              {[1, 2, 3, 4, 5].map((i) => (
                <div key={i} className="space-y-2">
                  <div className={`h-4 w-24 animate-pulse rounded ${colors.accent}`} />
                  <div className="h-16 animate-pulse rounded bg-white" />
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export const PostGenerationSkeletonMemo = memo(PostGenerationSkeleton);
